import React from 'react';
import { useState } from 'react';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import { sendOTP } from '../../api/user';
// import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

const BasicDetails = ({ setNext, handleChange, values }) => {
    // const { user } = useSelector((state) => ({ ...state }));
    // const [OTP, setOTP] = useState('')
    // const [OTPnew, setOTPNew] = useState('')
    // const show = false;

    const handleNext = e => {
        e.preventDefault()
        setNext(false)
    }

    // const handleSendOTP = e => {
    //     e.preventDefault()
    //     if (values.phone.trim()) {
    //         sendOTP(user.token, user._id, values.phone)
    //             .then(res => {
    //                 setOTP(res.data)
    //                 toast.success('OTP send')
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //                 toast.error('OTP could not be sent, please verify your number')
    //             })
    //     } else {
    //         toast.error('Please enter your number')
    //     }
    // }

    // const verifyOTP = e => {
    //     e.preventDefault()
    //     if (OTPnew === OTP)
    //         toast.success('OTP verified')
    //     else
    //         toast.error('Wrong OTP')
    // }

    return (
        <>
            <div className="mb-3">
                <label htmlFor="name" className="form-label">Institute Name</label>
                <input value={values.name} name='name' type="text" className="form-control" id="name" onChange={handleChange} required />
            </div>
            <div className="mb-3">
                <div className="form-check form-check-inline">
                    <input checked={values.institute_type === 'college'} className="form-check-input" type="radio" name="institute_type" id="inlineRadio1" value="college" onChange={handleChange} />
                    <label className="form-check-label" htmlFor="inlineRadio1">College</label>
                </div>
                <div className="form-check form-check-inline">
                    <input checked={values.institute_type === 'school'} className="form-check-input" type="radio" name="institute_type" id="inlineRadio2" value="school" onChange={handleChange} />
                    <label className="form-check-label" htmlFor="inlineRadio2">School</label>
                </div>
            </div>
            <div className="mb-3">
                <label htmlFor="email" className="form-label">Institute Email</label>
                <input value={values.institute_email} type="email" name="institute_email" className="form-control" id="email" onChange={handleChange} required />
            </div>
            <div className="row mb-3">
                <div className="col">
                    <label htmlFor="phone" className="form-label">Phone Number</label>
                    <input value={values.phone} type="Number" name="phone" className="form-control" id="phone" onChange={handleChange} required />
                </div>
                {/* <div className="col">
                    <button onClick={handleSendOTP} className="btn btn-primary">OTP</button>
                </div> */}
            </div>
            {/* <div className="row mb-3">
                <div className="col">
                    <label htmlFor="phone" className="form-label">Phone Number</label>
                    <input type="Number" name="phone" className="form-control" id="phone" onChange={e => setOTPNew(e.target.value)} />
                </div>
                <div className="col">
                    <button onClick={verifyOTP} className="btn btn-primary">Verify</button>
                </div>
                {
                    show ? (
                        <div className="col">
                            <CloseOutlined style={{ fontSize: 30, color: 'red' }} />
                            <CheckOutlined style={{ fontSize: 30, color: 'green' }} />
                        </div>
                    ) : ''
                }
            </div> */}
            <button onClick={handleNext} className="btn btn-primary float-end">Next</button>
        </>
    )
}

const AddressDetails = ({
    setNext,
    address,
    handleAddressChange,
    handleCityChange,
    handleCountryChange,
    loading,
    loadingCities,
    countries,
    cities,
    setLoadingCities,
    setCities
}) => {

    const handlePrev = e => {
        e.preventDefault()
        setNext(true)
    }

    const handleCountrySelect = async e => {
        setLoadingCities(true)
        if (e.target.value !== 'Please select the country') {
            try {
                const country = countries.filter(each => (each.country === e.target.value))
                setCities(country[0].cities)
                handleCountryChange(e.target.value)
                handleCityChange('')
                setLoadingCities(false)
            } catch (error) {
                console.log(error)
            }
        } else {
            handleCountryChange('')
            setCities([])
            handleCityChange('')
        }
    }

    const handleCitySelect = async e => {
        if (e.target.value !== 'Please select the city') {
            try {
                handleCityChange(e.target.value)
            } catch (error) {
                console.log(error)
            }
        } else {
            handleCityChange('')
        }
    }

    return (
        loading ? <h1>loading</h1> :
            <>
                <div className="mb-3">
                    <label htmlFor="name" className="form-label">Address</label>
                    <input type="text" value={address.fisrt_line} name="fisrt_line" className="form-control mb-3" id="name" onChange={handleAddressChange} required />
                    <input type="text" value={address.second_line} name="second_line" className="form-control" id="name" onChange={handleAddressChange} />
                </div>
                {
                    countries && (
                        <select onChange={handleCountrySelect} name="country" className="form-select mb-3" value={address.country} required >
                            <option defaultValue>Please select the country</option>
                            {
                                countries.map((each, i) => (
                                    <option key={i} value={each.country}>{each.country}</option>
                                ))
                            }
                        </select>
                    )
                }
                {
                    cities && (
                        <select className="form-select mb-3" name="city" disabled={loadingCities} onChange={handleCitySelect} value={address.city} required >
                            <option defaultValue>Please select the city</option>
                            {
                                cities.map((each, i) => (
                                    <option key={i} value={each}>{each}</option>
                                ))
                            }
                        </select>
                    )
                }
                <div className="mb-3">
                    <label htmlFor="pincode" className="form-label">Pincode</label>
                    <input type="Number" name="pincode" className="form-control mb-3" id="pincode" onChange={handleAddressChange} value={address.pincode} required />
                </div>
                <button onClick={handlePrev} className="btn btn-primary">Previous</button>
                <button type="submit" className="btn btn-primary float-end">Submit</button>
            </>
    )
}


const InstituteForm = ({
    values,
    handleChange,
    handleAddressChange,
    handleSumbit,
    handleCityChange,
    handleCountryChange,
    loading,
    loadingCities,
    countries,
    cities,
    setLoading,
    setLoadingCities,
    setCities
}) => {
    const [next, setNext] = useState(true)
    return (
        <form onSubmit={handleSumbit}>
            {next ?
                <BasicDetails
                    handleChange={handleChange}
                    handleAddressChange={handleAddressChange}
                    setNext={setNext}
                    values={values}
                />
                : <AddressDetails
                    handleChange={handleChange}
                    handleAddressChange={handleAddressChange}
                    setNext={setNext}
                    handleCityChange={handleCityChange}
                    handleCountryChange={handleCountryChange}
                    address={values.address}
                    loading={loading}
                    setLoading={setLoading}
                    loadingCities={loadingCities}
                    setLoadingCities={setLoadingCities}
                    countries={countries}
                    cities={cities}
                    setCities={setCities}
                />}
        </form>
    );
};

export default InstituteForm;